var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	7601: () => (loadSingletonVersion("default", "@angular/core", false, [4,19,2,21], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_10e24").then(() => (() => (__webpack_require__(/*! @angular/core */ 7580))))))),
	6851: () => (loadSingletonVersion("default", "@angular/common", false, [4,19,2,21], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4623").then(() => (() => (__webpack_require__(/*! @angular/common */ 316))))))),
	661: () => (loadSingletonVersion("default", "@angular/common/http", false, [4,19,2,21], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9342").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 6443))))))),
	768: () => (loadSingletonVersion("default", "@angular/core", false, [1,19,1,6], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_10e23").then(() => (() => (__webpack_require__(/*! @angular/core */ 7580))))))),
	2554: () => (loadSingletonVersion("default", "@angular/router", false, [1,19,1,6], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a220").then(() => (() => (__webpack_require__(/*! @angular/router */ 5072))))))),
	5474: () => (loadSingletonVersion("default", "@angular/common/http", false, [1,19,1,6], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9340").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 6443))))))),
	7494: () => (loadSingletonVersion("default", "@angular/common", false, [1,19,1,6], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4622").then(() => (() => (__webpack_require__(/*! @angular/common */ 316))))))),
	2438: () => (loadSingletonVersion("default", "@angular/core", false, [,[1,19,0,0],[1,18,0,0],1], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_10e20").then(() => (() => (__webpack_require__(/*! @angular/core */ 7580))))))),
	4768: () => (loadSingletonVersion("default", "@angular/common", false, [,[1,19,0,0],[1,18,0,0],1], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4620").then(() => (() => (__webpack_require__(/*! @angular/common */ 316))))))),
	7567: () => (loadSingletonVersion("default", "@angular/core", false, [0,16,0,0], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_10e21").then(() => (() => (__webpack_require__(/*! @angular/core */ 7580))))))),
	865: () => (loadSingletonVersion("default", "@angular/common", false, [0,16,0,0], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(/*! @angular/common */ 316))))))),
	5399: () => (loadSingletonVersion("default", "@angular/core", false, [1,19,0,0], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_10e21").then(() => (() => (__webpack_require__(/*! @angular/core */ 7580))))))),
	825: () => (loadSingletonVersion("default", "@angular/common", false, [1,19,0,0], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(/*! @angular/common */ 316))))))),
	5346: () => (loadSingletonVersion("default", "@angular/common/http", false, [,[1,19,0,0],[1,18,0,0],1], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9342").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 6443))))))),
	4935: () => (loadSingleton("default", "@angular/core", false, () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_10e22").then(() => (() => (__webpack_require__(/*! @angular/core */ 7580)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"node_modules_angular_common_fesm2022_http_mjs-_f9341": [
		7601
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4622": [
		7601
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a221": [
		6851,
		7601,
		661
	],
	"projects_mfewidget-core_src_bootstrap_ts": [
		6851,
		7601,
		768,
		2554,
		5474,
		7494,
		2438,
		4768,
		661
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a220": [
		6851,
		7601,
		661
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		7601
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		7601
	],
	"projects_mfewidget-core_src_app_modules_mfe_auth_auth_module_ts-_70af1": [
		7567,
		865,
		5399,
		825,
		5346
	],
	"projects_mfewidget-core_src_app_modules_client_views_kyc-link_kyc-link_component_ts": [
		7567,
		865
	],
	"projects_mfewidget-core_src_app_modules_dynamic-form_dynamic-form_module_ts-_96a21": [
		5399,
		825,
		7567,
		865,
		5346
	],
	"projects_mfewidget-core_src_app_modules_access_access_module_ts-_d08a1": [
		5399,
		825,
		7567,
		865,
		5346
	],
	"projects_mfewidget-core_src_app_modules_security_security_module_ts-_6b831": [
		7567,
		865,
		5399,
		825,
		5346
	],
	"projects_mfewidget-core_src_app_modules_dashboard_dashboard_module_ts-_a87a1": [
		4935,
		5399,
		825,
		7567,
		865,
		5346
	],
	"projects_mfewidget-core_src_app_modules_recharge_recharge_module_ts-_b6e51": [
		4935,
		5399,
		825,
		7567,
		865,
		5346
	],
	"projects_mfewidget-core_src_app_modules_records_records_module_ts-_dd4a1": [
		5399,
		825,
		7567,
		865,
		5346
	],
	"projects_mfewidget-core_src_app_modules_transfer_transfer_module_ts-_39ea1": [
		4935,
		5399,
		825,
		7567,
		865,
		5346
	],
	"projects_mfewidget-core_src_app_modules_custodian_custodian_module_ts-_efe21": [
		5399,
		825,
		7567,
		865,
		5346
	],
	"projects_mfewidget-core_src_app_modules_user_user_module_ts-_8e221": [
		5399,
		825,
		7567,
		865,
		5346
	],
	"projects_mfewidget-core_src_app_modules_withdraw_withdraw_module_ts-_555f1": [
		4935,
		5399,
		825,
		7567,
		865,
		5346
	],
	"projects_mfewidget-core_src_app_modules_generic_pin-setup-dialog_pin-setup-dialog_component_t-3557d71": [
		7567,
		865,
		5346
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}